import React, { useContext } from "react"
import { CustomersPage as SharedCustomersPage } from "@stjeans/shared-frontend/customers"
import AppContext from "../../AppContext.jsx"
import api from "../../api.js"
import * as helpers from "../../helpers.js"

export default function CustomersPage() {
    const { app } = useContext(AppContext)

    return (
        <SharedCustomersPage
            app={app}
            api={api}
            helpers={helpers}
            enableStatusColumn={false}
            enableTypeColumn={false}
            showStatusDropdown={false}
            showTypesDropdown={false}
            // @ts-ignore - lodge-only UI behavior
            disableCustomerWritesWhenOffline={app?.connected === false}
            // @ts-ignore - shared customer slideout props are intentionally loose
            customerSlideoutProps={{
                enableStatus: false,
                enableCommunication: false,
                enableTypeBadges: false,
                enableLodge: false,
                ordersTableYearParam: "all",
            }}
        />
    )
}
